var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useRef } from 'react';
import Dropzone from 'react-dropzone';
import styled from 'styled-components';
import * as filesAPI from '@debbie/cortex/dist/api/files';
import { APIBASE } from '../config';
import THEME from '../theme';
import X from './Icons/X';
import { Button } from '.';
const ImageInput = (props) => {
    const dropzoneRef = useRef(null);
    return (React.createElement(Styled, null, 
    // @ts-ignore
    React.createElement(Dropzone, { multiple: false, ref: dropzoneRef, acceptStyle: {
            background: 'lightgreen',
        }, rejectStyle: {
            background: 'red',
        }, disableClick: true, onDrop: (acceptedFiles) => __awaiter(void 0, void 0, void 0, function* () {
            if (props.onChange) {
                const uploadFile = acceptedFiles[0];
                const content = yield promiseFileReader(uploadFile);
                const { file } = yield filesAPI.save({
                    content: content.split('base64,')[1],
                    name: uploadFile.name,
                    contentType: uploadFile.type,
                });
                props.onChange(file);
            }
        }) }, props.image ? (React.createElement(ImageContainer, null,
        React.createElement(X, { style: {
                float: 'right',
                cursor: 'pointer',
            }, onClick: () => {
                if (props.onChange)
                    props.onChange(null);
            } }),
        React.createElement("img", { src: `${APIBASE}/files/${props.image.fileId}/${props.image.fileName}` }))) : (React.createElement("div", null,
        React.createElement(Button, { style: {
                display: 'block',
                margin: '7px auto',
            }, onClick: () => {
                var _a;
                // @ts-ignore
                (_a = dropzoneRef.current) === null || _a === void 0 ? void 0 : _a.open();
            } }, "Upload"))))));
};
export default ImageInput;
const promiseFileReader = (file) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => __awaiter(void 0, void 0, void 0, function* () {
            resolve(event.target.result);
        });
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
});
const ImageContainer = styled.div `
  img {
    object-fit: contain;
    object-position: left bottom;
    margin-top: 15px;
    margin-bottom: 15px;
    height: 60px;
    width: 216px;
    margin: 0 auto;
    display: block;
  }
`;
const Styled = styled.div `
  background-color: #e6e6e6;
  border-radius: 2px;
  padding: ${THEME.GRID_SPACING}px;
  margin-bottom: ${THEME.GRID_SPACING}px;
`;
//# sourceMappingURL=ImageInput.js.map